import "./checkboxStyles.scss";

import type { ChangeEvent } from "react";
import { FC, memo } from "react";

import { DoneIcon } from "../icons/DoneIcon";

interface IProps {
  checked: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  value: string;
  disabled?: boolean;
}

const Checkbox: React.FC<IProps> = memo(
  ({ onChange, checked, value, disabled }) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      onChange(event);
    };
    return (
      <div className="styled-checkbox">
        <label className="styled-checkbox__label">
          <input
            type="checkbox"
            onChange={handleChange}
            checked={checked}
            value={value}
            disabled={disabled}
          />
          <div
            data-testid="checkbox"
            className={`styled-checkbox-container ${checked ? "checked" : ""} ${
              disabled ? "styled-checkbox__disabled" : ""
            }`}
          >
            {checked && <DoneIcon />}
          </div>
        </label>
      </div>
    );
  },
);

export { Checkbox };
